import { Component, Prop, Vue, Watch } from 'vue-property-decorator';


@Component({})
export default class Quantity extends Vue {

  @Prop({type: Number, default: null})
  totalQty: number;

  @Prop({type: Boolean, default: false})
  isLearner: boolean;

  @Prop({type: Number, default: 0})
  additionalQty: number;

  @Prop({type: Number, default: 1})
  minValue: number;

  @Prop({type: Number, default: 999})
  maxValue: number;

  @Prop({type: String, default: null})
  authorOnly: string;

  @Prop({type: Array, default: null})
  learnerAuthorList: any;

  @Prop({type: Object, default: null})
  learner: any;

  @Prop({type: Boolean, default: false})
  isSilver: boolean;


  public localQty = null;
  public error = null;
  public learnerAuthor = null;
  public additionalAuthors = 0;
  public showAdditionalAuthors = false;


  public created(): void {
    this.init();
  }

  public init() {
    this.localQty = this.totalQty;
    if (this.isSilver) {
      this.localQty = 1;
    }
    this.additionalAuthors = this.additionalQty;
    if (this.isLearner) {
      this.learnerAuthor = this.learnerAuthorList.find((l) => l.learner === this.totalQty);
    }

    this.showAdditionalAuthors = this.additionalAuthors > 0;
  }


  @Watch('isLearner')
  qtyChange() {
    this.init();
  }

  public toLearner() {
    this.$emit('toLearner', this.learner);
  }

  public validateQuatity() {
    this.error = null;
    const regex = /[1-9]|\./;
    if( !regex.test(this.localQty) ) {
      this.localQty = null;
      this.error = 'This item cannot be removed. You must have at least one item in order to check out.';
    } else {
      this.update();
    }

    this.updateError();
  }

  public resetAdditionalAuthors() {
    this.showAdditionalAuthors = false;
    this.additionalAuthors  = 0;
    this.update();

  }

  public update() {
    this.$emit('updateQty', this.localQty, this.additionalAuthors);
  }

  public updateError() {
    this.$emit('updateError', this.error);
  }

  public onPlus() {
    this.error = null;
    this.updateError();
    if (this.localQty) {
      this.localQty++;
    } else {
      this.localQty = 1;
    }

    this.update();
  }

  public onMinus() {
    this.error = null;
    this.updateError();
    if (this.localQty && this.localQty > 1) {
      this.localQty--;
    } else {
      this.localQty = 1;
    }
    this.update();
  }

  public learnerChange() {
    this.localQty = this.learnerAuthor.learner;
    this.update();
  }

  public authorChange() {
    this.update();
  }
}
